import { z } from 'zod';

export const userFacilityRoleSchema = z.object({
  facilityId: z.uuid(),
  facilityName: z.string(),
  roleId: z.uuid(),
  roleName: z.string(),
});

export const userSummarySchema = z.object({
  id: z.uuid(),
  email: z.string(),
  displayName: z.string(),
  status: z.enum(['active', 'disabled']),
  facilityRoles: z.array(userFacilityRoleSchema),
});

export type UserSummary = z.infer<typeof userSummarySchema>;
